import router from './router';
import store from './store';
import iView from 'iview';
import {getToken} from "./utils/auth";
import {Message} from 'iview';
import axios from 'axios'
// 全局设置提示框
Message.config({
  duration: 5
})

const whiteList = ['/login', '/404','/mobile'];

router.beforeEach(async (to, from, next) => {

  store.getters.source.cancel()
  store.commit('SET_SOURCE',axios.CancelToken.source())


  iView.LoadingBar.start();
  let menuList=store.getters.menuList

  if(to.name && menuList &&  to.path==='/'){
    if( menuList.indexOf(to.name)===-1  ){
      next({path: '/404'});
      iView.LoadingBar.finish();  //手动修改url 不触发afterEach
      return
    }
  }

  //增加pc 、移动端交互处理
  let viewMeta = document.getElementsByTagName('meta')[1]
  if(to.name==='mobile'){
    viewMeta.content="initial-scale=1.0, user-scalable=no"
  }else {
    viewMeta.content='width=1800, initial-scale=1, maximum-scale=1, user-scalable=1'
  }

  //
  //增加 存在token直接到首页
  if(to.path==='/login'){

    if(getToken()){

      if(!store.getters.addRouters.length){
        if(store.getters.menuList){
          store.dispatch('GenerateRoutes', store.getters.menuList)
          router.addRoutes(store.getters.addRouters)
        }
      }
      if(store.getters.addRouters.length &&store.getters.addRouters[0].children){
        next({name: store.getters.addRouters[0].children[0].name});
        iView.LoadingBar.finish();  //手动修改url 不触发afterEach
        return
      }
    }
  }


  if (whiteList.indexOf(to.path) !== -1) {
    next()
    return
  }

  if (!getToken()) {
    next({path: 'login'});
    iView.LoadingBar.finish();  //手动修改url 不触发afterEach
    return
  }

  // //针对工作台的特殊处理
  // if (to.path === '/workbench/index' || to.name === 'workbench') {
  //   store.dispatch('updateCollapsed', false)
  // } else {
  //   store.dispatch('updateCollapsed', true)
  // }


  if (!store.getters.addRouters.length) {
    if (!store.getters.menuList) {
      try {
        await store.dispatch('getAuthority')
        await store.dispatch('GenerateRoutes', store.getters.menuList)
        if (store.getters.addRouters.length) {
          router.addRoutes(store.getters.addRouters)
          // router.push({name: store.getters.addRouters[0].name});
          next({...to})
        }

      }catch (e) {

      }
    }
    else {
     await store.dispatch('GenerateRoutes', store.getters.menuList)
      router.addRoutes(store.getters.addRouters)
      next({...to})
      // toNext(to,next)
    }
  }
  else {
    next();
  }


});

router.afterEach((to,from) => {
  iView.LoadingBar.finish();

})

